import { useBreeds, useColors, useGenders } from '../../queries/CommonQueries';
import { useParams } from 'react-router';
import { useAlpacaDataOnly } from '../../queries/AlpacaQueries';
import { useFarms } from '../../queries/FarmQueries';
import AddUpdateAlpacaForm from '../../components/AddUpdateAlpacaForm';
import type { Alpaca } from '../../models/Alpaca';
import { useUserDetails } from '../../helpers/UserContext';
import ShowPending from '../../components/ShowPending';
import AppLayout from '../../components/AppLayout';

export default function UpdateAlpaca() {
  const params = useParams();
  const id = params.id ? +params.id : 0;
  const [userDetails] = useUserDetails();

  const { data: breeds = [] } = useBreeds();
  const { data: colors = [] } = useColors();
  const { data: genders = [] } = useGenders();
  const { data: alpaca, isPending } = useAlpacaDataOnly(id);
  const { data: farms = [] } = useFarms('');

  return (
    <AppLayout>
      <main>
        <h3 className='text-center text-2xl dark:text-gray-300'>
          {id > 0 ? 'Update' : 'Add'} Alpaca
        </h3>
        {id > 0 && isPending ? (
          <ShowPending isPending={isPending} />
        ) : (
          <AddUpdateAlpacaForm
            genders={genders}
            breeds={breeds}
            colors={colors}
            farms={farms}
            alpaca={
              alpaca ??
              ({
                applicationUserId: userDetails?.userId ?? '',
                alpacaId: 0,
                active: true,
              } as Alpaca)
            }
          />
        )}
      </main>
    </AppLayout>
  );
}
